import { WebHttpRequestOptions } from '@am92/web-http'

import { getAppVersionServiceName, getAppVersionTraceActions } from '../Actions'

import serviceActionCreatorWithTokenRotation from '~/src/Redux/serviceActionCreatorWithTokenRotation'

import { APP_VERSION } from '~/src/Configurations/env'
import { asHttp } from '~/src/Configurations/WebHttp'

import { TAppVersion } from '~/src/Entities/App/App.Types'

async function getAppVersion() {
  const reqData = { currentVersion: APP_VERSION }
  const options: WebHttpRequestOptions = {
    url: '/app/get-version',
    method: 'POST',
    data: reqData
  }

  const response = await asHttp.request(options)
  const { data: body } = response
  const { data } = body
  return data as TAppVersion
}

const getAppVersionService = serviceActionCreatorWithTokenRotation(
  getAppVersionTraceActions,
  getAppVersion
)

export default getAppVersionService
export { getAppVersionServiceName }
